import axios from "axios";

export const getRatingList = async () => {
    const ratingMapUrl = window.settings.layoutUrlBase + "assets/rating-map.json";
    return await axios.get(ratingMapUrl).then(response => response.data)
}
